import {
  ChannelkartNetworkGet,
  ChannelkartNetworkPost,
  ChannelkartNetworkPut,
} from "./networkService";
import { EnvironmentRegistry } from "../services/registry/environmentRegistry";

const url = EnvironmentRegistry.getRewardsUrl();
const size = 1000;

export const getTasks = async (requestBody: object): Promise<any[]> => {
  let allTasks: any[] = [];
  let page = 0;

  try {
    while (true) {
      const response = await ChannelkartNetworkPost(
        `${url}/v1/loyalty/task?size=${size}&page=${page}`,
        requestBody
      );

      const tasks = response?.data?.content ?? response?.data ?? [];
      allTasks.push(...tasks);

      if (tasks.length < size) break;
      page++;
    }
  } catch (error) {
    console.error("Error fetching all tasks:", error);
  }

  return allTasks;
};

export async function createTask(postBody: object) {
  const response = await ChannelkartNetworkPost(
    `${url}/v1/loyalty/OutletAssignment`,
    postBody
  );
  return response;
}

export async function updateTask(postBody: object) {
  const response = await ChannelkartNetworkPut(
    `${url}/v1/loyalty/updateRule`,
    postBody
  );
  return response;
}

export async function createCampaign(postBody: object) {
  const response = await ChannelkartNetworkPost(
    `${url}/v1/loyalty/campaign`,
    postBody
  );
  return response;
}
